import React from 'react';
import { ContainerList, ContainerListHeader } from './styles';
import { strings } from '../../../resources/strings';
import { StateLog } from '../../../models/StateLog';
import { OrderGeneralOption } from '../../../enums/OrderGeneralOption';
import ServicesContext from '../../../contexts/ServicesContext';
import { useAuth } from '../../../contexts/AuthContext';
import { OrderInTransport } from '../../../services/Orders/GetOrdersInTransport/OrderInTransport';
import { GetOrdersInTransportInput } from '../../../services/Orders/GetOrdersInTransport/GetOrdersInTransportInput';
import { Table } from '../../../common-components/Table/Table';
import { ModalHistory } from '../../../components/ModalHistory/ModalHistory';
import { ModalManageCarrier } from '../../../components/ModalManageCarrier/ModalManageCarrier';
import { useOrdersInTransportTable } from './useOrdersInTransportTable';
import { OrdersInTransportTableHeader } from './OrdersInTransportTableHeader';
import { OrdersInTransportTableRow } from './OrdersInTransportTableRow';

interface IOrdersInTransportProps {
  ordersInTransport?: OrderInTransport[];
  filterAreaHeight: number;
  newStateOrder?: (newState: StateLog) => void;
  refreshRow?: (orderInTransport?: OrderInTransport | null) => void;
}

const OrdersInTransport: React.FC<IOrdersInTransportProps> = ({
  ordersInTransport,
  filterAreaHeight,
  newStateOrder,
  refreshRow
}) => {

  const { session } = useAuth();
  const [modalHistoryOrderVisible, setModalHistoryOrderVisible] = React.useState<boolean>(false);
  const [modalHistoryOrderId, setModalHistoryOrderId] = React.useState<number | undefined>(undefined);
  const [modalHistoryTitle, setModalHistoryTitle] = React.useState<string>('');
  const [modalManageCarrierVisible, setModalManageCarrierVisible] = React.useState<boolean>(false);
  const [modalManageCarrierTitle, setModalManageCarrierTitle] = React.useState<string>(strings.ManageTransport);
  const [modalManageCarrierOrderId, setModalManageCarrierOrderId] = React.useState<number | undefined>(undefined);
  const [modalManageCarrierOrderNumber, setModalManageCarrierOrderNumber] = React.useState<string | undefined>(undefined);
  const { getWidthColumns } = useOrdersInTransportTable();

  const {
    getOrdersInTransportService
  } = React.useContext(ServicesContext);

  const widthColumn = React.useMemo(() => getWidthColumns(), []);

  const rowsRender = React.useMemo(() => {
    const render = ordersInTransport?.map(orderInTransport => {
      return (
        <OrdersInTransportTableRow
          key={`order-${orderInTransport.orderId}`}
          orderInTransport={orderInTransport}
          widthColumn={widthColumn}
          handleGeneralOption={handleGeneralOption}
          newStateOrder={newStateOrder}
          session={session}
        />
      );
    }) || [];
    return render;
  }, [ordersInTransport, widthColumn]);

  return (
    <>
      <ContainerListHeader>
        <Table>
          <thead>
            <OrdersInTransportTableHeader />
          </thead>
        </Table>
      </ContainerListHeader>
      <ContainerList filterAreaHeight={filterAreaHeight}>
        <Table>
          <tbody>
            {rowsRender}
          </tbody>
        </Table>
      </ContainerList>
      <ModalHistory
        visible={modalHistoryOrderVisible}
        orderId={modalHistoryOrderId}
        close={() => closeModalHistory()}
        title={modalHistoryTitle}
      />
      <ModalManageCarrier
        visible={modalManageCarrierVisible}
        orderId={modalManageCarrierOrderId}
        orderNumber={modalManageCarrierOrderNumber}
        close={() => closeModalManageCarrier(modalManageCarrierOrderNumber)}
        title={modalManageCarrierTitle}
      />
    </>
  );

  function handleGeneralOption(orderInTransport: OrderInTransport, key: any) {
    if (key === OrderGeneralOption.Historic) {
      setModalHistoryOrderId(orderInTransport.orderId);
      setModalHistoryTitle(`${strings.Historic} #${orderInTransport.orderNumber}`);
      setModalHistoryOrderVisible(true);
      return;
    }
    if (key === OrderGeneralOption.ManageTransport) {
      setModalManageCarrierVisible(true);
      setModalManageCarrierTitle(`${strings.ManageTransport} #${orderInTransport.orderNumber}`);
      setModalManageCarrierOrderId(orderInTransport.orderId);
      setModalManageCarrierOrderNumber(orderInTransport.orderNumber);
      return;
    }
  }

  function closeModalHistory() {
    setModalHistoryOrderId(undefined);
    setModalHistoryTitle('');
    setModalHistoryOrderVisible(false);
  }

  async function closeModalManageCarrier(orderNumber?: string) {
    setModalManageCarrierOrderId(undefined);
    setModalManageCarrierOrderNumber(undefined);
    setModalManageCarrierVisible(false);

    if (!orderNumber || !refreshRow) return;

    const filterInput = new GetOrdersInTransportInput();
    filterInput.numbers = orderNumber.toString();
    const result = await getOrdersInTransportService.handle(filterInput);
    const orderInTransport = result?.value?.list?.find(x => x.orderNumber === orderNumber) || null;
    refreshRow(orderInTransport);
  }
}

export { OrdersInTransport };